const PageTitle = ({ title, subTitle }: { title: string, subTitle: string }) => {
    return (
        <div className="page-title">
            <h2>{title}</h2>
            <p>{subTitle}</p>
        </div>
    );
}   

export default PageTitle;